export function createResetMutation(initState) {
  return function reset(state) {
    const initialState = initState();
    Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
  };
}
